import React, { useEffect, useRef, useState } from 'react'
import { Table, message } from 'antd'
import { ColumnsType } from 'antd/es/table'
import useGlobalModel from '@/model/globalModel'
import { YHModal } from '@/components/YHModal'
import { EditableRow, EditableCell } from '@/components/YHEditTable/editTable'
import { baseRoutineModel } from '../routineModel'
import { globalPrompt } from '@/components/message'
import { routineService } from '../routineService'

export const AddRoutineModal = () => {
    const [dataSource, setDataSource] = useState<any>([])
    const { addCarVisible, setAddCarVisible, loadData } = baseRoutineModel()
    const formRef = useRef<any>()
    const {
        user: { shopCode, createUser },
    } = useGlobalModel(({ user }) => [user])
    const [saveLoading, setSaveLoading] = useState<boolean>(false) //  保存按钮
    useEffect(() => {
        setDataSource([
            {
                temporaryId: new Date().getTime() + Math.floor(Math.random() * 10000),
                createUserId: shopCode,
                createUser: createUser,
            },
        ])
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [addCarVisible])
    useEffect(() => {
        formRef.current = dataSource
    }, [dataSource])
    const DeleteRow = (record: any) => {
        const data = formRef.current.filter((i) => record.temporaryId !== i.temporaryId)
        setDataSource(data)
    }
    const AddRow = (record: any) => {
        const dataIndex = formRef.current.findIndex((i) => record.temporaryId === i.temporaryId)
        const newData = dataSource
        newData.splice(dataIndex + 1, 0, {
            temporaryId: new Date().getTime() + Math.floor(Math.random() * 10000),
            createUserId: shopCode,
            createUser: createUser,
        })
        setDataSource([...newData])
    }
    const columns = [
        {
            title: '操作',
            width: 140,
            fixed: 'left',
            align: 'center',
            render: (t: any, r: any) => (
                <>
                    {dataSource.length > 1 && (
                        <span
                            style={{
                                fontSize: '14px',
                                color: '#4165E3',
                                cursor: 'pointer',
                            }}
                            onClick={() => DeleteRow(r)}
                        >
                            删除
                        </span>
                    )}
                    <span
                        style={{
                            fontSize: '14px',
                            color: '#4165E3',
                            cursor: 'pointer',
                            marginLeft: '15px',
                        }}
                        onClick={() => AddRow(r)}
                    >
                        新增一行
                    </span>
                </>
            ),
        },
        {
            title: (
                <span>
                    路线名称 <span style={{ color: 'red' }}> *</span>
                </span>
            ),
            width: 120,
            dataIndex: 'lineName',
            editable: true,
            align: 'center',
        },
        {
            title: (
                <span>
                    起点 <span style={{ color: 'red' }}> *</span>
                </span>
            ),
            width: 140,
            dataIndex: 'startingPoint',
            editable: true,
            align: 'center',
        },
        {
            title: '途经点',
            width: 120,
            dataIndex: 'pathwayPoints',
            editable: true,
            align: 'center',
        },
        {
            title: (
                <span>
                    终点 <span style={{ color: 'red' }}> *</span>
                </span>
            ),
            width: 120,
            dataIndex: 'endPoint',
            editable: true,
            align: 'center',
        },
        {
            title: '备注',
            width: 120,
            dataIndex: 'note',
            editable: true,
            align: 'center',
        },
        {
            title: '创建人',
            width: 200,
            dataIndex: 'createUser',
            align: 'center',
            // editable: true,
        },
    ]

    const newColumn = columns.map((col: any, index) => {
        return {
            ...col,
            onCell: (record: any, rowIndex: number) => ({
                colIndex: index + 1,
                rowIndex,
                record,
                rules: col.rules,
                options: col.options,
                editType: col.editType,
                editable: col?.editable,
                dataIndex: col.dataIndex,
                title: col.title,
                handleSave: handleSave,
                onInputEnter: col.onInputEnter,
            }),
        }
    })
    //内联编辑
    const handleSave = (row: any) => {
        const newData = [...dataSource]
        const index = newData.findIndex((item) => row.temporaryId === item.temporaryId)
        const item = newData[index]
        newData.splice(index, 1, { ...item, ...row })
        setDataSource(newData)
    }

    const onOk = async () => {
        let errorList: any = []
        dataSource.forEach((item) => {
            if (!item.lineName || !item.startingPoint || !item.endPoint) {
                errorList.push(item.licensePlate)
            }
        })
        if (errorList.length > 0) {
            return message.warning(`请补全${errorList}必填信息，再继续操作！`)
        }
        try {
            setSaveLoading(true)
            let { retData } = await routineService.insert(dataSource)
            setSaveLoading(false)
            setAddCarVisible(false)
            message.success(`添加成功！`)
            loadData()
            return retData
        } catch (error) {
            setSaveLoading(false)
        }
    }

    const onClose = () => {
        globalPrompt('modal', {
            title: '新增路线',
            type: 'warning',
            text: '您还有正在新增的路线记录...是否关闭？',
            okText: '关闭页面',
            onOk: () => setAddCarVisible(false),
            cancelText: '继续添加',
            onCancel: () => {
                return
            },
        })
    }

    return (
        <YHModal
            visible={addCarVisible}
            title="您正在添加路线..."
            cancelText="取消添加"
            okText="确定添加"
            onCancel={onClose}
            onOk={onOk}
            width={'70%'}
            showFooter={true}
        >
            <Table
                loading={saveLoading}
                rowKey={(record) => record.temporaryId}
                columns={newColumn as ColumnsType<any>}
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    },
                }}
                dataSource={dataSource}
                scroll={{ x: 'max-content' }}
                pagination={false}
                bordered
                // footer={() => <span style={{ color: '#999999', cursor: 'pointer' }} onClick={() => AddRow()}><NodeIndexOutlined />新增一行</span>}
            />
        </YHModal>
    )
}
